import { DEFAULT_TOOLBOX_MODEL } from "./constants.js";

export type RouteRule = {
  maxTokens?: number;
  keywords?: string[];
  complexity: "low" | "medium" | "high";
  targetModel: string;
};

const TECH_KEYWORDS = [
  "code",
  "sql",
  "diff",
  "function",
  "class",
  "typescript",
  "python",
  "api",
  "debug",
  "refactor",
  "algorithm",
];

export interface Router {
  addRule(rule: RouteRule): void;
  determineModel(prompt: string): Promise<{ model: string; reason: string }>;
}

export function createRouter(defaultModel = DEFAULT_TOOLBOX_MODEL): Router {
  const rules: RouteRule[] = [];

  return {
    addRule(rule: RouteRule) {
      rules.push(rule);
    },

    async determineModel(prompt: string) {
      let complexity: RouteRule["complexity"] = "medium";

      if (prompt.length < 200) {
        complexity = "low";
      } else if (TECH_KEYWORDS.some((kw) => prompt.toLowerCase().includes(kw))) {
        complexity = "high";
      }

      const match =
        rules.find((r) => r.complexity === complexity) ??
        rules.find((r) => r.complexity === "medium");

      if (match) {
        return {
          model: match.targetModel,
          reason: `Matched ${complexity} complexity rule`,
        };
      }

      return { model: defaultModel, reason: `Default model for ${complexity} complexity` };
    },
  };
}
